import { ReactElement } from "react";

import ThreeQuarterCircle from "./ThreeQuarterCircle";

export const SpinningCircle = (): ReactElement => (
  <ThreeQuarterCircle
    sx={{
      height: 20,
      animation: "spin 2s linear infinite",
      "@keyframes spin": {
        "0%": {
          transform: "rotate(360deg)",
        },
        "100%": {
          transform: "rotate(0deg)",
        },
      },
    }}
  />
);
